var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-subheader-wrapper"},[_c('div',{staticClass:"page-subheader-inner"},[_c('div',{staticClass:"page-subheader-title"},[_c('h2',[_vm._v(_vm._s(_vm.sectionTitle))])]),_c('div',{staticClass:"page-subheader-slot"},[_c('div',{staticClass:"page-subheader-slot-inner"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }